"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkPanelHealthcareSubtype = void 0;
exports.networkPanelHealthcareSubtype = { "HOSPITAL": { "name": { "code": "HOSPITAL", "localize": { "en": "Hospitals", "th": "โรงพยาบาล" } } }, "CLINIC": { "name": { "code": "CLINIC", "localize": { "en": "Clinics", "th": "คลินิก" } } }, "PHARMACY": { "name": { "code": "PHARMACY", "localize": { "en": "Pharmacies", "th": "ร้านขายยา" } } } };
